export const CheckoutPaths = {
  Summary: 'summary',
  AddOns: 'add-ons',
  AccountSetup: 'account-setup',
  FinalMile: 'final-mile',
} as const
